'use client'

import UIFlex from '@components/ui/UIFlex'
import UIText from '@components/ui/UIText'
import { Radio, RadioGroup } from '@mui/joy'
import color from '@ui/style/color.theme'
import { pxToRem } from '@ui/style/muiTheme'
import IconOsm from 'src/assets/icons/IconOsm'
import IconXsm from 'src/assets/icons/IconXsm'
import { PollSetProps } from './types'
import { Answer } from '@schemas/non-auth'

const PollOxSet = ({ poll, auth, selected, setSelected, authAction }: PollSetProps) => {
	const targetCode = poll.participationTargetCode?.code
	const handleSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (targetCode === 'MEMBER-ONLY' && !auth) {
			authAction()
		} else if ((targetCode === 'MEMBER-ONLY' && auth) || targetCode === 'ALL') {
			setSelected([e.target?.value as string])
		}
	}
	const drawPllOXAnswer = (answer: Answer, index: number) => {
		return (
			<UIFlex width="50%" key={`answer-${answer.answerIdx}`}>
				<Radio
					value={answer.answerIdx}
					label={
						<>
							{index % 2 === 0 ? <IconOsm /> : <IconXsm />}
							<UIText readonly>{answer.answerContent}</UIText>
						</>
					}
					disableIcon
					slotProps={{
						action: {
							sx: {
								top: 0,
								left: 0,
								right: 0,
								bottom: 0,
								border: 0,
								opacity: 0,
							},
						},
						label: ({ checked }) => ({
							sx: {
								display: 'flex',
								width: '100%',
								height: pxToRem(88),
								borderRadius: pxToRem(8),
								border: `1px solid ${
									checked ? color.colPointBlue : color.colGray3
								}`,
								background: checked ? color.colLightBlue : color.colWhite,
								flexGrow: 1,
								alignItems: 'center',
								justifyContent: 'center',
							},
						}),
					}}
					checked={selected.includes(answer.answerIdx.toString())}
					onChange={handleSelect}
				/>
			</UIFlex>
		)
	}
	return (
		<RadioGroup name="poll-ox-group">
			<UIFlex
				flexDirection="row"
				sx={{
					'&>*:not(:first-child)': {
						marginLeft: pxToRem(16),
					},
				}}
			>
				{poll.answerList?.map(drawPllOXAnswer)}
			</UIFlex>
		</RadioGroup>
	)
}

export default PollOxSet
